import { render } from "./IngresoJefatura.vue?vue&type=template&id=95ecf43a&scoped=true"
import script from "./IngresoJefatura.vue?vue&type=script&lang=js"
export * from "./IngresoJefatura.vue?vue&type=script&lang=js"

import "./IngresoJefatura.vue?vue&type=style&index=0&id=95ecf43a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-95ecf43a"]])

export default __exports__